import ModalConfirmCheckout from "components/ModalConfirmCheckout";
import ModalUploadImage from "components/ModalUploadImage";
import ModalFakturPajak from "components/ModalFakturPajak";
import {
  addPremiumToCart,
  checkoutProcess,
} from "features/common/layouts/cartSlice";
import {
  buildProductPayload,
  getServerIdOnly,
  postOrderAPI,
} from "helpers/helper";
import ModalLogin from "layouts/ModalLogin";
// import ModalRegister from "layouts/ModalRegister";
import ModalRegisterSimple from "layouts/ModalRegisterSimple";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notifyError, notifySuccess } from "components/ToastMessage";
import ModalSubDomain from "components/ModalSubDomain";
import { Spinner } from "react-bootstrap";
import ModalPph from "components/ModalPph";
import ModalNetInstallation from "components/ModalNetInstallation";
import { useLocation } from "react-router-dom";

const CheckoutButton = ({
  orderProcessName,
  productsList,
  paymentMethod,
  orderProcess,
  requirement,
  promoCode,
  ktpCard,
  conditionalDomain,
  availableOnlineId,
  documentNpwp,
  documentPph,
  documentSuratSubdomain,
  additionalFee,
  subtotal,
  total,
  pricepph,
  domainBundle,
  onlineIdCheckExist,
  orderParams,
}) => {
  const dispatch = useDispatch();
  const {
    productsList: cartProductsList,
    paymentMethod: cartPaymentMethod,
    requirement: cartRequirement,
    promoCode: cartPromoCode,
    total: cartTotal,
    orderProcessName: cartOrderProcessName,
    documentNpwp: cartDocumentNpwp,
    documentPph: cartDocumentPph,
    npwpUrl,
    existingDomain,
    ktpCard: cartKtpCard,
    domainBundle: cartDomainBundle,
    documentSuratSubdomain: cartDocumentSuratSubdomain,
    pricepph: cartPricepph,
  } = useSelector((state) => state.cart);

  const { nameservers } = useSelector((state) => state.domain);
  const { status_login, data_login } = useSelector((state) => state.auth);
  const location = useLocation();
  const [showLogin, setModalLogin] = useState(false);
  const [showDaftar, setModalDaftar] = useState(false);
  const [modalImage, setModalImage] = useState(false);
  const [modalFaktur, setModalFaktur] = useState(false);
  const [modalPph, setModalPph] = useState(false);
  const [modalSubDomain, setModalSubDomain] = useState(false);
  const [modalNetInstallation, setModalNetInstallation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalConfirmation, setModalConfirmation] = useState(false);
  const [isPass, setIsPass] = useState(false);
  const [isNetAvailable, setIsNetAvailable] = useState(false);

  const { ktp_client = null } = data_login?.client ?? {};
  const { uploadStatus } = cartKtpCard;
  // const promocode = cartPromoCode?.code ?? null;

  const product = cartProductsList.find((obj) => obj.pid);
  const backorder = cartProductsList.find((obj) => obj.pid === 382);
  const domain = cartProductsList.filter((obj) => obj.domain).map((obj) => obj);
  const pid = cartProductsList.filter((obj) => obj.pid).map((obj) => obj);
  const gid = cartProductsList.filter((obj) => obj.gid).map((obj) => obj);

  const vpnGid = [
    { id: 685, serverName: 'DiegoVPN' }
  ]

  const wordpressServer = [
    { id: 706, serverName: 'SouthJKT-1 (Cyber 1 - Tier III)' },
    { id: 707, serverName: 'SouthJKT-2 (MTEN - Tier III)' },
  ]

  const vpsServer = [
    { id: 688, serverName: 'SouthJKT-1 (Cyber 1 - Tier III)' },
    { id: 697, serverName: 'SouthJKT-2 (MTEN - Tier III)' },
    { id: 701, serverName: 'WestJavaBDG-1 (BBU - Tier III)' },
    { id: 725, serverName: 'USA (Tier III)' }
  ]

  const velocityProduct = useSelector((state) => state.cart.velocityProduct);

  // Reset loading state when user successfully logs in after registration
  useEffect(() => {
    if (status_login === true && (showLogin || showDaftar)) {
      // User has successfully logged in and modals are still open
      // console.log('User logged in, closing modals and resetting loading');
      setModalLogin(false);
      setModalDaftar(false);
      resetLoadingState();
    }
  }, [status_login, showLogin, showDaftar]);

  // Reset loading state when modals are closed
  useEffect(() => {
    if (!showLogin && !showDaftar && loading) {
      // If both modals are closed but loading is still true, reset it
      // console.log('Modals closed, resetting loading state');
      resetLoadingState();
    }
  }, [showLogin, showDaftar, loading]);

  // Additional safety: Reset loading when user becomes logged in
  useEffect(() => {
    if (status_login === true && loading) {
      // console.log('User is logged in, resetting loading as safety measure');
      resetLoadingState();
    }
  }, [status_login, loading]);

  // Listen for internet offer status from CheckoutTable
  useEffect(() => {
    const handleNetOfferStatus = (event) => {
      const status = event.detail.status;
      // Set isNetAvailable to true only if status is "Tersedia"
      setIsNetAvailable(status === "Tersedia");
    };

    window.addEventListener('updateInternetOfferStatus', handleNetOfferStatus);
    return () => {
      window.removeEventListener('updateInternetOfferStatus', handleNetOfferStatus);
    };
  }, []);

  // Reset net offer states when user logs out or leaves order summary page
  useEffect(() => {
    if (!status_login || location.pathname !== "/ordersummary") {
      setIsNetAvailable(false);
      setModalNetInstallation(false);
    }
  }, [status_login, location.pathname]);

  const addOrderProcess = async (isNewUser) => {
    try {
      if (!cartPaymentMethod) {
        throw new Error("Metode pembayaran belum dipilih");
      }
      let endpoint;
      let payloadOrderTest = {
        paymentmethod: isNewUser
          ? cartPaymentMethod.valueNewUser
            ? cartPaymentMethod.valueNewUser
            : cartPaymentMethod.value
          : cartPaymentMethod.value,
        amount_total: cartTotal,
        promocode: cartPromoCode?.code,
        npwp: cartRequirement?.company,
        npwp_no: cartRequirement?.company ? cartDocumentNpwp.formData.npwp_no : "",
        npwp_address: cartRequirement?.company ? cartDocumentNpwp.formData.npwp_address : "",
        npwp_company: cartRequirement?.company ? cartDocumentNpwp.formData.npwp_company : "",
        npwp_image: cartRequirement?.company ? npwpUrl : "",
        document_pph: cartRequirement?.pph ? cartDocumentPph.url : "",
        price_pph: cartRequirement?.pph ? cartPricepph : "",
        surat_kuasa_subdomain: cartRequirement?.tos ? cartDocumentSuratSubdomain.suratUrl : "",
        apply_credit: false,
      };

      switch (cartOrderProcessName) {
        case "domain":
          payloadOrderTest["domains"] = domain.map((d) => ({
            domain: d.domain,
            idprotection: d?.isWhois ?? false,
            regperiod: d.duration,
            domaintype: d.type,
            eppcode: d?.eppCode ?? "",
            domain_forwarder:
              d?.domainForwarder === "Activate Later"
                ? null
                : d.domainForwarder || null,
            activate_later: d?.activateLater || false,
          }));

          payloadOrderTest["nameserver"] = nameservers
            ? nameservers
            : [
              "dnsiix1.goldenfast.net",
              "dnsiix2.goldenfast.net",
              "dns1.goldenfast.id",
              "dns2.goldenfast.id",
            ];

          payloadOrderTest["online_id"] = cartDomainBundle.onlineId || null;
          endpoint = "domain";
          break;
        case "domainBackorder":
          payloadOrderTest["domain"] = backorder.name;
          payloadOrderTest["pid"] = backorder.pid;
          payloadOrderTest["customfields"] = backorder.customfields;
          endpoint = "backorder";
          break;
        case "hosting":
          if (Array.isArray(pid)) {
            const filteredPid = pid.filter((pidObj) => pidObj.pid !== 110);
            const filteredSsl = pid.filter((pidObj) => pidObj.pid === 110);
            payloadOrderTest["hostings"] = filteredPid.map((pidObj) => {
              // Initialize addons array
              let addons = pidObj?.addon ? [pidObj?.addon.id] : [];

              // Check if cartDocumentPph.url is not empty and add addon ID 55 if true
              if (cartDocumentPph.url) {
                addons.push(55); // Add addon ID 55
              }
              console.log(velocityProduct);
              // Jika ada velocityProduct dan GID sesuai (730 atau 731), gunakan data velocityProduct
              if (velocityProduct && (pidObj.gid === 730 || pidObj.gid === 731)) {
                return {
                  pid: velocityProduct.pid, // Gunakan PID dari velocityProduct
                  billingcycle: velocityProduct.billingcycle,
                  addons: addons,
                  price: velocityProduct.priceWithAddon || velocityProduct.price,
                };
              }

              // Jika tidak ada velocityProduct, gunakan data normal
              return {
                pid: pidObj.pid,
                billingcycle: pidObj.billingcycle,
                addons: addons,
                price: pidObj?.price ? pidObj.price : 0,
              };
            });
            payloadOrderTest["ssl"] = filteredSsl.map((pidObj) => ({
              pid: pidObj.pid,
              price: pidObj.price,
              billingcycle: pidObj?.billingcycle ?? pidObj?.duration ?? "",
              customfields: Array.isArray(pidObj?.customfields)
                ? pidObj.customfields.map((cf) => ({
                  id: cf.id,
                  value: cf.value,
                }))
                : [],
              configoptions: Array.isArray(pidObj?.configoptions)
                ? pidObj.configoptions.map((co) => ({
                  id: co.id,
                  value: co.value,
                }))
                : [],
              addons: pidObj?.addon ? [pidObj?.addon.id] : [],
            }));
          } else {
            payloadOrderTest["hostings"] = [];
            payloadOrderTest["ssl"] = [];
          }

          if (existingDomain) {
            payloadOrderTest["domains"] = [
              { ...existingDomain, idprotection: false },
            ];
          } else {
            payloadOrderTest["domains"] = domain.map((item) => ({
              domain: item.domain,
              idprotection: item?.whois ?? false,
              regperiod: item.duration,
              domaintype: item.type,
              eppcode: item?.eppCode ?? "",
            }));
          }

          gid.forEach(function (item) {
            if (item.gid === 709 || item.gid === "709") {
              payloadOrderTest["nameserver"] = nameservers
                ? nameservers
                : ["ns1.fastcloud.id", "ns2.fastcloud.id"];
            } else {
              if (nameservers) {
                payloadOrderTest["nameserver"] = nameservers;
              }
            }
          });

          if (
            cartPromoCode.customPromo === "Promo Kaos Tumbler" &&
            cartPromoCode.paymentGateway === ""
          ) {
            payloadOrderTest["notes"] = "Gratis kaos dan tumbler";
          } else if (
            cartPromoCode.customPromo === "" &&
            cartPromoCode.paymentGateway === "Gratis Payment Gateway"
          ) {
            payloadOrderTest["notes"] = "Gratis Payment Gateway";
          } else if (
            cartPromoCode.customPromo === "Promo Kaos Tumbler" &&
            cartPromoCode.paymentGateway === "Gratis Payment Gateway"
          ) {
            payloadOrderTest["notes"] =
              "Gratis kaos dan tumbler dan Gratis Payment Gateway";
          }

          if (payloadOrderTest["hostings"].length === 0) {
            // Jika tidak ada hosting, tambahkan nameserver dan online_id seperti domain order
            payloadOrderTest["nameserver"] = nameservers
              ? nameservers
              : [
                "dnsiix1.goldenfast.net",
                "dnsiix2.goldenfast.net",
                "dns1.goldenfast.id",
                "dns2.goldenfast.id",
              ];
            payloadOrderTest["online_id"] = cartDomainBundle.onlineId || null;

            // Update format domains untuk domain-only order
            payloadOrderTest["domains"] = domain.map((d) => ({
              domain: d.domain,
              idprotection: d?.isWhois ?? false,
              regperiod: d.duration,
              domaintype: d.type,
              eppcode: d?.eppCode ?? "",
              domain_forwarder:
                d?.domainForwarder === "Activate Later"
                  ? null
                  : d.domainForwarder || null,
              activate_later: d?.activateLater || false,
            }));

            endpoint = "domain";
          } else {
            endpoint = "hosting";
          }
          break;
        case "migrasiHosting":
          if (Array.isArray(pid)) {
            const filteredPid = pid.filter((pidObj) => pidObj.pid !== 110);
            const filteredSsl = pid.filter((pidObj) => pidObj.pid === 110);
            payloadOrderTest["hostings"] = filteredPid.map((pidObj) => {
              // Initialize addons array
              let addons = pidObj?.addon ? [pidObj?.addon.id] : [];

              // Check if cartDocumentPph.url is not empty and add addon ID 55 if true
              if (cartDocumentPph.url) {
                addons.push(55); // Add addon ID 55
              }

              return {
                pid: pidObj.pid,
                billingcycle: pidObj.billingcycle,
                addons: addons,
                price: pidObj?.price ? pidObj.price : 0,
              };
            });

            payloadOrderTest["ssl"] = filteredSsl.map((pidObj) => ({
              pid: pidObj.pid,
              price: pidObj.price,
              billingcycle: pidObj?.billingcycle ?? pidObj?.duration ?? "",
              customfields: Array.isArray(pidObj?.customfields)
                ? pidObj.customfields.map((cf) => ({
                  id: cf.id,
                  value: cf.value,
                }))
                : [],
              configoptions: Array.isArray(pidObj?.configoptions)
                ? pidObj.configoptions.map((co) => ({
                  id: co.id,
                  value: co.value,
                }))
                : [],
              addons: pidObj?.addon ? [pidObj?.addon.id] : [],
            }));
          } else {
            payloadOrderTest["hostings"] = [];
            payloadOrderTest["ssl"] = [];
          }

          if (existingDomain) {
            payloadOrderTest["domains"] = [
              { ...existingDomain, idprotection: false },
            ];
          } else {
            payloadOrderTest["domains"] = domain.map((item) => ({
              domain: item.domain,
              idprotection: item?.whois ?? false,
              regperiod: item.duration,
              domaintype: item.type,
              eppcode: item?.eppCode ?? "",
            }));
          }
          gid.forEach(function (item) {
            if (item.gid === 709 || item.gid === "709") {
              payloadOrderTest["nameserver"] = nameservers
                ? nameservers
                : ["ns1.fastcloud.id", "ns2.fastcloud.id"];
            } else {
              if (nameservers) {
                payloadOrderTest["nameserver"] = nameservers;
              }
            }
          });
          if (
            cartPromoCode.customPromo === "Promo Kaos Tumbler" &&
            cartPromoCode.paymentGateway === ""
          ) {
            payloadOrderTest["notes"] =
              "Invoice ini meminta untuk melakukan migrasi hosting dan gratis kaos dan tumbler";
          } else if (
            cartPromoCode.customPromo === "" &&
            cartPromoCode.paymentGateway === "Gratis Payment Gateway"
          ) {
            payloadOrderTest["notes"] =
              "Invoice ini meminta untuk melakukan migrasi hosting dan gratis payment gateway";
          } else if (
            cartPromoCode.customPromo === "Promo Kaos Tumbler" &&
            cartPromoCode.paymentGateway === "Gratis Payment Gateway"
          ) {
            payloadOrderTest["notes"] =
              "Invoice ini meminta untuk melakukan migrasi hosting, gratis kaos dan tumbler dan gratis payment gateway";
          } else {
            payloadOrderTest["notes"] =
              "Invoice ini meminta untuk melakukan migrasi hosting";
          }
          endpoint = "hosting";
          break;
        case "vps":
          if (Array.isArray(pid)) {
            const filteredPid = pid.filter(
              (pidObj) => pidObj.pid !== 110 && pidObj.pid !== 449
            );
            const filteredSsl = pid.filter(
              (pidObj) => pidObj.pid === 110 || pidObj.pid === 449
            );

            // Prepare VPS data for new server endpoint
            payloadOrderTest["vps"] = filteredPid.map((pidObj) => {
              // Initialize addons array
              let addons = Array.isArray(pidObj?.vpsaddons)
                ? pidObj.vpsaddons.map((addon) => addon.id)
                : [];

              // Check if cartDocumentPph.url is not empty and add addon ID 55 if true
              if (cartDocumentPph.url) {
                addons.push(55); // Add addon ID 55
              }

              return {
                pid: pidObj.pid,
                billingcycle: pidObj.billingcycle,
                hostname: pidObj.hostname || pidObj.rootpw, // Fix: use hostname field
                rootpw: pidObj.rootpw || pidObj.password, // Fix: use rootpw field
                addons: addons,
                customfields: Array.isArray(pidObj?.customfields)
                  ? pidObj.customfields.map((cf) => ({
                    id: cf.id,
                    value: cf.value,
                  }))
                  : [],
                configoptions: Array.isArray(pidObj?.configoptions)
                  ? pidObj.configoptions.map((co) => ({
                    id: co.id,
                    value: co.value,
                  }))
                  : [],
              };
            });

            // Add SSL as additional addons if any
            if (filteredSsl.length > 0) {
              const sslAddons = filteredSsl.map((ssl) => ssl.pid);
              payloadOrderTest["addons"] = sslAddons;
            }
          } else {
            payloadOrderTest["vps"] = [];
            payloadOrderTest["addons"] = [];
          }

          endpoint = "vps"; // Use vps endpoint
          break;
        case "diegoVpn":
          let product_account = [];
          pid.map((p) => {
            for (let j = 0; j < p.account; j++) {
              product_account.push(p);
            }
            return null;
          });
          payloadOrderTest["products"] = product_account;
          endpoint = "general";
          break;
        case "emailsuite":
          payloadOrderTest["products"] = buildProductPayload(
            pid,
            cartDocumentPph.url
          );
          if (existingDomain) {
            payloadOrderTest["domains"] = [
              { ...existingDomain, idprotection: false },
            ];
          } else {
            payloadOrderTest["domains"] = domain.map((item) => ({
              domain: item.domain,
              idprotection: item?.whois ?? false,
              regperiod: item.duration,
              domaintype: item.type,
              eppcode: item?.eppCode ?? "",
            }));
          }
          endpoint = "general";
          break;
        default: // ? orderProcessName = 'others'
          payloadOrderTest["products"] = buildProductPayload(
            pid,
            cartDocumentPph.url
          );
          if (existingDomain) {
            payloadOrderTest["domains"] = [
              { ...existingDomain, idprotection: false },
            ];
          } else {
            payloadOrderTest["domains"] = domain.map((item) => ({
              domain: item.domain,
              idprotection: item?.whois ?? false,
              regperiod: 2,
              domaintype: item.type,
              eppcode: item?.eppCode ?? "",
            }));
          }
          endpoint = "general";
          break;
      }
      const orderResult = await postOrderAPI(payloadOrderTest, endpoint);

      return orderResult;
    } catch (error) {
      console.log(error.message);
      // notifyError(error.message);
      const errorPayload = {
        code: 500,
        result: error.message,
        msg: error.message,
        data: null
      };
      dispatch(checkoutProcess(false));
      return errorPayload;
    }
  };

  const resetLoadingState = () => {
    // console.log('Resetting loading state');
    setLoading(false);
  };

  const handlerCloseModal = () => {
    setModalConfirmation(false);
    setIsPass(true);
    resetLoadingState();
  };

  const redirectToInvoice = (invoiceId) => {
    window.location.href = `${process.env.REACT_APP_BASE_API}viewinvoice.php?id=${invoiceId}`;
    localStorage.removeItem("persist:root");
  };

  const checkoutHandle = async (e) => {
    if (
      domain &&
      (cartOrderProcessName === "domain" ||
        cartOrderProcessName === "hosting" ||
        cartOrderProcessName === "migrasiHosting")
    ) {
      setLoading(true);
      for (const name of domain) {
        try {
          const premium = cartProductsList.find(
            (obj) => obj.premium_domain === name.domain
          );
          if (premium) {
            // setLoading(false);
          } else {
            // Tambahkan timeout 5 detik
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000);

            try {
              const response = await fetch(
                `${process.env.REACT_APP_BASE_API}apis/checkPremium.php?domain=${name.domain}`,
                { signal: controller.signal }
              );
              clearTimeout(timeoutId);
              const result = await response.json();

              if (result) {
                if (result.datas?.data?.isPremium === 1) {
                  dispatch(
                    addPremiumToCart({
                      name: "Biaya One Time",
                      price: result.datas.data.price.IDR - name.price,
                      type: "Premium Domain",
                      premium_domain: name.domain,
                    })
                  );
                  notifySuccess("Domain yang Anda pesan adalah Domain Premium.");
                  setLoading(false);
                  return;
                }
              }
            } catch (error) {
              // Jika timeout atau error, bypass pengecekan premium
              // console.log("Premium check bypassed:", error);
              clearTimeout(timeoutId);
              continue;
            }
          }
        } catch (error) {
          console.log(error);
          setLoading(false);
          return;
        }
      }
    }

    if (status_login === false) {
      // console.log('User not logged in, showing login modal');
      setModalLogin(true);
      resetLoadingState(); // Reset loading state when showing login modal
      return;
    }

    if (cartOrderProcessName === "hosting" && !isPass) {
      let hostings = {};
      hostings["hosting"] = Object.values(pid).map((pidObj) => ({
        pid: pidObj.pid,
        billingcycle: pidObj.billingcycle,
        addons: pidObj?.addon ? [pidObj?.addon.id] : [],
      }));
      if (hostings["hosting"].length === 0) {
        setModalConfirmation(true);
        return;
      }
    }

    try {
      /**
       *  TODO : Show modal upload KTP or Open Camera for (VPS, Wordpress Hosting, DiegoVPN, Colocation & Dedicated Server)
       */
      const mergedServer = getServerIdOnly(
        vpsServer.concat(wordpressServer, vpnGid)
      );

      if (mergedServer.includes(product?.gid) && !ktp_client) {
        if (uploadStatus !== "user_agree") {
          setModalImage(true);
          return;
        }
      }

      if (
        existingDomain &&
        existingDomain.domain &&
        !cartDocumentSuratSubdomain.suratUrl
      ) {
        let tldString;
        let domainName;
        let isSubdomain;
        let tld = existingDomain.domain.split(".");
        let arrConditionalDomain = [
          ".ac.id",
          ".co.id",
          ".sch.id",
          ".or.id",
          ".ponpes.id",
          ".web.id",
          ".go.id",
        ];
        if (tld.length === 4) {
          tldString = "." + tld[2] + "." + tld[3];
          domainName = tld[1] + "." + tld[2] + "." + tld[3];
          isSubdomain = true;
        } else if (tld.length === 3) {
          tldString = "." + tld[1] + "." + tld[2];
          domainName = tld[0] + "." + tld[1] + "." + tld[2];
          isSubdomain = false;
        } else {
          tldString = "." + tld[1];
          domainName = tld[0] + "." + tld[1];
          isSubdomain = false;
        }

        if (arrConditionalDomain.includes(tldString) && isSubdomain) {
          setLoading(true);
          try {
            const clientId = data_login?.client?.id;
            if (!clientId) {
              console.log("Client ID not found for domain check");
              setLoading(false);
              return;
            }
            
            const response = await fetch(
              `${process.env.REACT_APP_BASE_API}/apis/checkOwnerDomain.php?domain=${domainName}&clientid=${clientId}`
            );
            const data = await response.json();
            if (data.code !== "200") {
              setModalSubDomain(true);
              setLoading(false);
              return;
            } else {
              setLoading(false);
            }
          } catch (error) {
            console.log(error);
            setLoading(false);
          }
        }
      }

      if (cartRequirement?.company === true && !npwpUrl) {
        setModalFaktur(true);
        return;
      }

      if (cartRequirement?.pph === true && !cartDocumentPph.url) {
        setModalPph(true);
        return;
      }

      // Check net installation offer before checkout
      if (location.pathname === "/ordersummary" && isNetAvailable) {
        setModalNetInstallation(true);
        return;
      }

      e.target.innerText = "Loading...";
      e.target.disabled = true;
      dispatch(checkoutProcess(true));

      if (cartProductsList.length === 0) {
        setTimeout(() => {
          e.target.innerText = "Checkout";
          e.target.disabled = false;
          dispatch(checkoutProcess(false));
        }, 2000);
        return;
      }

      let isNewUser = true;

      // if(data_login){
      // 	const userCreatedAt = new Date(data_login.user.created_at);
      // 	const cutoffDate = new Date('2023-10-11T00:00:00');

      // 	if (userCreatedAt >= cutoffDate) {
      // 		isNewUser = true;
      // 	} else {
      // 		isNewUser = false;
      // 	}
      // }

      // console.log("Sebelum addOrderProcess");
      const order = await addOrderProcess(isNewUser);
      console.log("Order response:", JSON.stringify(order, null, 2));

      // Validasi order response
      if (!order) {
        throw new Error("Tidak ada response dari server");
      }

      if (order?.code === 400) {
        throw new Error(order?.msg || "Bad Request");
      }
      if (
        cartOrderProcessName === "domain" ||
        cartOrderProcessName === "emailsuite" ||
        cartOrderProcessName === "domainBackorder"
      ) {
        if (order?.data?.order?.result === "success") {
          setTimeout(() => {
            redirectToInvoice(order.data.order.invoiceid);
          }, 5000); // 5 seconds
        } else {
          setTimeout(() => {
            e.target.innerText = "Checkout";
            e.target.disabled = false;
            dispatch(checkoutProcess(false));
            notifyError(order?.result || order?.msg || "Terjadi kesalahan saat memproses pesanan");
          }, 2000);
        }
      } else {
        if (order?.code === 200 && order?.data?.order) {
          const { invoiceid = 0 } = order.data.order;
          redirectToInvoice(invoiceid);
        } else {
          // Handle case where order response is not as expected
          e.target.innerText = "Checkout";
          e.target.disabled = false;
          dispatch(checkoutProcess(false));
          notifyError(order?.result || order?.msg || "Format response tidak valid");
        }
      }
    } catch (err) {
      console.warn(err.message, "checkoutHandle Function");
      if (err.message === "Invalid Data") {
        notifyError(
          "Pemesanan Anda tidak valid. Silakan ulangi pemesanan Anda."
        );
      } else {
        notifyError(err.message);
      }
      e.target.innerText = "Checkout";
      e.target.disabled = false;
      dispatch(checkoutProcess(false));
    }
  };

  const modalHideHandler = () => {
    setModalImage(false);
    resetLoadingState();
  };

  const handleNetInstallationSkip = () => {
    setModalNetInstallation(false);
    setIsNetAvailable(false); // Mark as not available so it won't show again
    // Continue with checkout process
    continueCheckout();
  };

  const handleNetInstallationAccept = () => {
    setModalNetInstallation(false);
    setIsNetAvailable(false); // Mark as not available so it won't show again
    // Continue with checkout process
    continueCheckout();
  };

  const handleNetInstallationHide = () => {
    setModalNetInstallation(false);
    resetLoadingState();
  };

  const continueCheckout = async () => {
    const checkoutButton = document.getElementById("checkoutButton");
    if (checkoutButton) {
      checkoutButton.innerText = "Loading...";
      checkoutButton.disabled = true;
      dispatch(checkoutProcess(true));

      if (cartProductsList.length === 0) {
        setTimeout(() => {
          checkoutButton.innerText = "Checkout";
          checkoutButton.disabled = false;
          dispatch(checkoutProcess(false));
        }, 2000);
        return;
      }

      try {
        let isNewUser = true;
        const order = await addOrderProcess(isNewUser);
        console.log("Order response:", JSON.stringify(order, null, 2));

        // Validasi order response
        if (!order) {
          throw new Error("Tidak ada response dari server");
        }

        if (order?.code === 400) {
          throw new Error(order?.msg || "Bad Request");
        }

        if (
          cartOrderProcessName === "domain" ||
          cartOrderProcessName === "emailsuite" ||
          cartOrderProcessName === "domainBackorder"
        ) {
          if (order?.data?.order?.result === "success") {
            setTimeout(() => {
              redirectToInvoice(order.data.order.invoiceid);
            }, 5000); // 5 seconds
          } else {
            setTimeout(() => {
              checkoutButton.innerText = "Checkout";
              checkoutButton.disabled = false;
              dispatch(checkoutProcess(false));
              notifyError(order?.result || order?.msg || "Terjadi kesalahan saat memproses pesanan");
            }, 2000);
          }
        } else {
          if (order?.code === 200 && order?.data?.order) {
            const { invoiceid = 0 } = order.data.order;
            redirectToInvoice(invoiceid);
          } else {
            // Handle case where order response is not as expected
            checkoutButton.innerText = "Checkout";
            checkoutButton.disabled = false;
            dispatch(checkoutProcess(false));
            notifyError(order?.result || order?.msg || "Format response tidak valid");
          }
        }
      } catch (err) {
        console.warn(err.message, "continueCheckout Function");
        if (err.message === "Invalid Data") {
          notifyError(
            "Pemesanan Anda tidak valid. Silakan ulangi pemesanan Anda."
          );
        } else {
          notifyError(err.message);
        }
        checkoutButton.innerText = "Checkout";
        checkoutButton.disabled = false;
        dispatch(checkoutProcess(false));
      }
    }
  };

  return (
    <>
      <div
        className={`${cartProductsList.length === 0 ? "mt-auto" : "mt-3"} d-grid`}
      >
        <button
          className="btn btn-cta rounded-5 checkout-button"
          id="checkoutButton"
          onClick={checkoutHandle}
          disabled={cartProductsList.length === 0 || loading}
        >
          {loading ? <Spinner animation="border" size="sm" /> : "Selesaikan Pesananmu"}
        </button>
      </div>

      <ModalLogin
        show={showLogin}
        onHide={() => {
          setModalLogin(false);
          resetLoadingState();
        }}
        onClickDaftar={(showDaftar) => {
          setModalDaftar(showDaftar);
          if (showDaftar) {
            setModalLogin(false);
          }
        }}
        onClickLogin={setModalLogin}
      />
      <ModalRegisterSimple
        show={showDaftar}
        onHide={() => {
          setModalDaftar(false);
          resetLoadingState();
        }}
        onClickDaftar={setModalDaftar}
        onClickLogin={(showLogin) => {
          setModalLogin(showLogin);
          if (showLogin) {
            setModalDaftar(false);
          }
        }}
      />
      <ModalUploadImage
        show={modalImage}
        onHide={modalHideHandler}
        handler={setModalImage}
        backdrop="static"
      />
      <ModalConfirmCheckout
        show={modalConfirmation}
        onHide={handlerCloseModal}
      />
      
      {/* Debug Button for Modal Faktur Pajak - Only visible in development */}
      {/* <div className="position-fixed" style={{ bottom: '20px', right: '20px', zIndex: 9999 }}>
        <button
          type="button"
          className="btn btn-warning btn-sm shadow"
          onClick={() => setModalFaktur(true)}
          title="Debug: Open Modal Faktur Pajak"
        >
          🔧 Test Faktur Pajak
        </button>
      </div> */}
      
      <ModalFakturPajak
        show={modalFaktur}
        onHide={() => {
          setModalFaktur(false);
          resetLoadingState();
        }}
      />
      <ModalPph
        show={modalPph}
        onHide={() => {
          setModalPph(false);
          resetLoadingState();
        }}
      />
      <ModalSubDomain
        show={modalSubDomain}
        onHide={() => {
          setModalSubDomain(false);
          resetLoadingState();
        }}
        domain={existingDomain ? existingDomain.domain : ""}
      />
      <ModalNetInstallation
        show={modalNetInstallation}
        onHide={handleNetInstallationHide}
        onSkip={handleNetInstallationSkip}
        onAccept={handleNetInstallationAccept}
      />
    </>
  );
};

export default CheckoutButton;
